<template>
  <v-select
    :label="label"
    :items="items"
    v-model="selected"
    multiple
    :dense="dense"
    :hide-details="hideDetails"
    :outlined="outlined"
    item-text="name"
    :item-value="itemValue"
    @change="onChange"
  ></v-select>
</template>

<script>
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../helpers";
const QUERY = gql`
  query serviceTypes($supplierTypes: [GtServiceType!]) {
    serviceTypes(supplierTypes: $supplierTypes, supplierType: ACCOMMODATION) {
      totalCount
      edges {
        node {
          id
          name
          notInUse
        }
      }
    }
  }
`;
export default {
  name: "service-type-multi-select",

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    supplierTypes: {
      type: Array,
      default: () => ["ACCOMMODATION"],
    },
    hideDetails: {
      type: Boolean,
      default: () => false,
    },
    dense: {
      type: Boolean,
      default: () => false,
    },
    outlined: {
      type: Boolean,
      default: () => false,
    },
    itemValue: {
      type: String,
      default: () => "name",
    },
    label: {
      type: String,
      default: () => "Service Type(s)",
    },
    hideNotInUse: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      debug: false,
      selected: [...this.value],
    };
  },

  computed: {
    items() {
      const list =
        this.serviceTypes && this.serviceTypes.edges
          ? this.serviceTypes.edges.map(removeGQLTypename)
          : [];

      return this.hideNotInUse ? list.filter((s) => !s.notInUse) : list;
    },
  },

  methods: {
    onChange() {
      this.$emit("input", [...this.selected]);
    },
  },

  apollo: {
    serviceTypes: {
      query: QUERY,
      variables() {
        return {
          supplierTypes: [...this.supplierTypes],
        };
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/shared/ServiceTypeMultiSelect.vue